// extracted by mini-css-extract-plugin
export default {"toggleIcon":"toggleIcon--xsLFT"};